import { useTranslations } from "use-intl";

import { BackButton } from "@/components/BackButton/BackButton";

export function MyBookingHeader() {
  const t = useTranslations();

  return (
    <div className="mb-4 flex items-center justify-between px-2 py-4">
      <BackButton />
      <h3 className="font-medium text-text-title">{t("orderDetails")}</h3>
      <div className="size-10" />
    </div>
  );
}
